import {
  userConstants
} from '../../store/actionTypes';

const initState = {
    loggedIn: false,
    loggedOut: false,
    isResetted: false,
    isForgot: false,
  };

const authReducer = (state = initState, action) => {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        ...state,
        loggedIn: true,
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        ...state,
        loggedIn: false,
      };
    case userConstants.LOGIN_FAILURE:
      return {
        ...state,
        loggedIn: false,
      };
    case userConstants.LOGOUT_REQUEST:
      return {
        ...state,
        loggedOut: true,
      };
    case userConstants.LOGOUT_SUCCESS:
      return {
        ...state,
        loggedOut: false,
      };
    case userConstants.LOGOUT_FAILURE:
      return state;
    default:
      return state
  }
}
export default authReducer;